
import React from "react";
import { Helmet } from "react-helmet";
import SEOMetadata from "@/components/SEOMetadata";
import OutdoorCoachingHero from "@/components/outdoor-coaching/HeroSection";
import BenefitsSection from "@/components/outdoor-coaching/BenefitsSection";
import WalkAndTalkSection from "@/components/outdoor-coaching/WalkAndTalkSection";
import RothseeSection from "@/components/outdoor-coaching/RothseeSection";
import ProcessSection from "@/components/outdoor-coaching/ProcessSection";
import PricingSection from "@/components/outdoor-coaching/PricingSection";
import TestimonialsSection from "@/components/outdoor-coaching/TestimonialsSection";
import FAQSection from "@/components/outdoor-coaching/FAQSection";
import AdditionalLocationsSection from "@/components/outdoor-coaching/AdditionalLocationsSection";
import OutdoorCoachingCTA from "@/components/outdoor-coaching/CTASection";
import { webPageStructuredData } from "@/data/structuredData";

const OutdoorCoaching: React.FC = () => {
  return (
    <>
      <SEOMetadata
        metaTitle="Coaching in der Natur Bayern & am Rothsee | Jörg Hörmann"
        metaDescription="Coaching in der Natur Bayerns: Walk & Talk am Rothsee für Führungskräfte und Selbstentscheider. 30 Minuten von Nürnberg."
        title="Coaching in der Natur Bayern & am Rothsee | Jörg Hörmann"
        description="Coaching in der Natur Bayerns: Walk & Talk am Rothsee für Führungskräfte und Selbstentscheider. 30 Minuten von Nürnberg."
        pageName="Outdoor-Coaching"
        primaryLink="/outdoor-coaching"
        canonicalUrl="https://joerg-hoermann.de/outdoor-coaching"
        keywords="Coaching in der Natur Bayern, Outdoor-Coaching Rothsee, Fränkisches Seenland Coaching, Walk Talk Coaching Bayern, Natur-Coaching Hilpoltstein, Outdoor Coaching Alpen, Coaching in der Natur Mittelfranken"
        imageUrl="/images/og-portrait.jpg"
      />
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(webPageStructuredData({
            name: "Outdoor-Coaching am Rothsee & in der Natur",
            description: "Walk & Talk Coaching in der Natur. Outdoor-Coaching am Rothsee, in den Alpen und an besonderen Orten in Bayern.",
            url: "https://joerg-hoermann.de/outdoor-coaching",
            aboutTopics: ["outdoorCoaching", "achtsamkeit", "neuroplastizitaet", "koerperintelligenz"]
          }))}
        </script>
      </Helmet>
      <OutdoorCoachingHero />


      {/* AI-Summary / AEO Abstract */}
      <section className="sr-only" aria-label="Zusammenfassung" data-speakable="summary">
        <p>Coaching in der Natur in Bayern: Jörg Hörmanns Outdoor-Coaching am Rothsee im Fränkischen Seenland nutzt das Signature-Format „Walk &amp; Talk" für neue Perspektiven. Wissenschaftlich belegt durch Studien zur Körperintelligenz und Neuroplastizität. Auch in den Alpen auf Anfrage verfügbar.</p>
      </section>
      {/* Golden Snippet – AEO Definition */}
      <section className="py-10 bg-white" data-speakable="definition">
        <div className="container mx-auto px-4">
          <p className="max-w-3xl mx-auto text-lg lg:text-xl text-joerg-700 leading-relaxed italic border-l-4 border-primary/30 pl-6">
            <strong className="not-italic">Was ist Outdoor-Coaching?</strong>{" "}
            Outdoor-Coaching am Rothsee ist Coaching in der Natur Bayerns. Im Gehen kommt in Bewegung, was im Büro festsitzt. Walk &amp; Talk bringt Bewegung ins Denken und Denken in Bewegung. Für Führungskräfte und Selbstentscheider, 30 Minuten von Nürnberg.
          </p>
        </div>
      </section>
      <BenefitsSection />
      <WalkAndTalkSection />
      {/* Golden Sentence – emotionaler Break */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <p className="max-w-2xl mx-auto text-center italic text-joerg-700 text-lg lg:text-xl leading-loose">
            „Im Nebeneinander-Gehen fallen Hierarchien. Am Rothsee entsteht der Raum für Offenheit – und damit für die Entscheidungen, die wirklich zählen."
          </p>
        </div>
      </section>

      <RothseeSection />
      <ProcessSection />
      <PricingSection />
      <TestimonialsSection />
      <FAQSection />
      <AdditionalLocationsSection />
      <OutdoorCoachingCTA />
    </>
  );
};

export default OutdoorCoaching;
